import { render } from "./AudioRecorder.vue?vue&type=template&id=de8aa044&scoped=true"
import script from "./AudioRecorder.vue?vue&type=script&lang=js"
export * from "./AudioRecorder.vue?vue&type=script&lang=js"

import "./AudioRecorder.vue?vue&type=style&index=0&id=de8aa044&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-de8aa044"]])

export default __exports__